// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCYMZcamaI4f_ffvyIvvSw9RjChdT-yMGM",
  authDomain: "bsafelinkr-eec06.firebaseapp.com",
  databaseURL: "https://bsafelinkr-eec06-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "bsafelinkr-eec06",
  storageBucket: "bsafelinkr-eec06.firebasestorage.app",
  messagingSenderId: "759917078265",
  appId: "1:759917078265:web:619109f68f163ee0a8a428"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);